
import { yupResolver } from '@hookform/resolvers/yup';
import Stack from '@mui/material/Stack'
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { object, string } from 'yup';

import { AppModal } from '.';
import { IAppModal } from '../../../compiler/global.interface';
import { useEditUserPasswordByUUID } from '../../../hook/query/userCRUD';
import { useSettingAccessUserPageContextContext } from '../../../pages/Setting/Access/User';
import { EHelperText } from '../../../utilitie/validation';
import { TextInput } from '../Input';
import { IAppModalProps } from './AppModal';
export interface IResetPasswordModalProps extends IAppModal, Omit<IAppModalProps, 'onConfirm'> {
    onConfirm?: (values: any) => any,
    loading?: boolean
}

export interface IResetPasswordFormValues{
    newPassword:string
}


export default function ResetPasswordModal({ onConfirm, loading, ...other }: IResetPasswordModalProps) {

    const { control, handleSubmit, setError, clearErrors, formState: { isValid }, reset, watch } = useForm<{
        new_password: string,
        confirm_new_password: string
    }>({
        mode: 'all',
        defaultValues: {
            new_password: '',
            confirm_new_password: ''
        },
        resolver: yupResolver(object().shape({
            new_password: string().required(EHelperText.REQUIRED).notAllowSpace().min(6,EHelperText.MIN + 6).matches(/^(?=.*\d)/,EHelperText.MIN + 1 + ' ' + EHelperText.NUMERIC).matches(/[a-zA-Z]/,EHelperText.MIN + 1 + ' ' + EHelperText.LETTER),
            confirm_new_password: string().required(EHelperText.REQUIRED).notAllowSpace().min(6,EHelperText.MIN + 6).matches(/^(?=.*\d)/,EHelperText.MIN + 1 + ' ' + EHelperText.NUMERIC).matches(/[a-zA-Z]/,EHelperText.MIN + 1 + ' ' + EHelperText.LETTER)
        }))
    })

    const _handleSubmit = async (values: FieldValues) => {
        onConfirm?.(values)
        reset({
            new_password: '',
            confirm_new_password: ''
        })
    }

    useEffect(() => {
        if (watch('new_password') !== watch('confirm_new_password')) {
            console.log('error')
            setError('new_password', { type: 'match', message: EHelperText.MATCH_PASSWORD })
        } else {
            clearErrors('new_password')
        }
    }, [watch('new_password'),watch('confirm_new_password')])

    return (
        <AppModal {...other} disabled={{onConfirm:!isValid}} loading={loading} onConfirm={handleSubmit(_handleSubmit, error => console.error(error))} title={'Reset Password'}>
            <Stack spacing={3}>
                <TextInput type="password" id='new_password' name='new_password' label='รหัสผ่านใหม่' control={control} />
                <TextInput type="password" id='confirm_new_password' name='confirm_new_password' label='ยืนยันรหัสผ่านใหม่' control={control} />
            </Stack>
        </AppModal>
    );
}
